import type { Editor } from '@tiptap/core';
import { TextSelection } from 'prosemirror-state';

export const changeSelectionToEndOfTextBlock = (editor: Editor) => {
  const { $anchor } = editor.view.state.selection;
  const range = $anchor.blockRange();
  if (range) {
    const selectedText = TextSelection.create(editor.view.state.doc, range?.end - 1);
    editor.view.dispatch(editor.view.state.tr.setSelection(selectedText));
  }
};
